/**
 * Created by jv on 2020-02-07 (15:34).
 */
import utils from "Sources/utils/utils";

let NavUtils = {};

NavUtils.setNavHighlight = function(href)
{
  href = utils.isNotNull(href) ? href : utils.getUrlPath();
  let $navLinks = $(".navbar-nav .nav-item a.nav-link");
  $navLinks.removeClass("active");

  $navLinks.each((index, el) =>
  {
    let $el = $(el);
    let navLink = $el.attr("href"),
        alternatives = $el.data("link-alternatives");

    let matches = false;
    let alternativeLinkExpressions = utils.isNotNull(alternatives) ? alternatives.split(";") : [];

    if(href === navLink || alternativeLinkExpressions.includes(href))
    {
      matches = true;
    }
    else
    {
      // Try via regex to see if it matches
      for(let i = 0; i < alternativeLinkExpressions.length; i++)
      {
        let regexp = new RegExp(alternativeLinkExpressions[i]);

        if(href.match(regexp))
        {
          matches = true;
          break;
        }
      }
    }

    if(matches)
    {
      $el.addClass("active");
    }
  });
};

export default NavUtils;



// WEBPACK FOOTER //
// ./app/js/utils/navigation-utils.js